export default __webpack_public_path__ + "static/media/icon_settings.a42e5b0e.svg";